<template>
    <div class="books-list">
        <PageHeader></PageHeader>
        <van-tabs v-model="active" animated>
            <van-tab title="推荐">
                <ul>
                    <BooksListItem v-for="(item, index) in recommendList" :key="index" :item="item"></BooksListItem>
                </ul>
            </van-tab>
            <van-tab title="男频">
                <ul>
                    <BooksListItem v-for="(item, index) in maleChannelList" :key="index" :item="item"></BooksListItem>
                </ul>
            </van-tab>
            <van-tab title="女频">
                <ul>
                    <BooksListItem v-for="(item, index) in femaleChannelList" :key="index" :item="item"></BooksListItem>
                </ul>
            </van-tab>
            <van-tab title="出版">
                <ul>
                    <BooksListItem v-for="(item, index) in publishList" :key="index" :item="item"></BooksListItem>
                </ul>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import BooksListItem from "@/components/BooksListItem.vue";

export default {
    components: {
        PageHeader,
        BooksListItem
    },
    data() {
        return {
            active: 0,
            recommendList: null,
            maleChannelList: null,
            femaleChannelList: null,
            publishList: null
        };
    },
    methods: {
        getBooksList(url, list) {
            this.axios.get("https://novel.kele8.cn/booklists?" + url).then(response => {
                this.$toast.loading({ message: "加载中...", forbidClick: true, loadingType: "spinner" });
                window.console.log(response.data);
                // 男
                if (list == "recommendList") {
                    ({ bookLists: this.recommendList } = response.data);
                }
                if (list == "maleChannelList") {
                    ({ bookLists: this.maleChannelList } = response.data);
                }
                if (list == "femaleChannelList") {
                    ({ bookLists: this.femaleChannelList } = response.data);
                }
                if (list == "publishList") {
                    ({ bookLists: this.publishList } = response.data);
                }

            }).finally(this.$toast.clear());
        }
    },
    created() {
        this.getBooksList("sort=collectorCount&duration=all&gender=male", "recommendList");
        this.getBooksList("sort=created&duration=all&gender=male", "maleChannelList");
        this.getBooksList("gender=female", "femaleChannelList");
        this.getBooksList("duration=last-seven-days&start=0 ", "publishList");
    }
};
</script>

<style lang="less" scope>
.van-tabs {
    .van-tab {
        font-size: 16px;
        font-weight: 600;
    }
    &--active {
        color: #323233;
        font-weight: 600;
    }
}
</style>
